import { useTranslation } from "react-i18next";
import { StatusCode } from "api/protocols";
import { ExportPowerCartPDF } from "api/rpc/2024-04/facilityAdmin/facility/powercart/powercart";
import Popup from "components/popup/Popup";
import TagInput from "components/tagInput/TagInput";
import { useAppDispatch } from "hooks/redux";
import React, { useState } from "react";
import { showError, showSuccess } from "redux/actions/ui";
import validator from "validator";

interface IExportPowerCartsProps {
  open: boolean;
  onClose: () => void;
}

export default function ExportPowerCarts({ open, onClose }: IExportPowerCartsProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [state, setState] = useState({
    newEmail: "",
    emails: [] as string[],
  });

  function handleAddNewEmail(event: KeyboardEvent) {
    if (event.key === "Enter" || event.key === ",") {
      const emails = state.emails.slice();
      const email = state.newEmail;

      if (!validator.isEmail(email)) {
        dispatch(showError(t("Please enter a valid email")));
        return;
      }

      emails.push(email);
      setState({ ...state, emails: emails, newEmail: "" });
    }
  }

  async function handleExportCustomerList() {
    const params = {
      emails: state.emails,
    };

    const exportPDFRes = await ExportPowerCartPDF(params, true);
    if (exportPDFRes?.status !== StatusCode.OK) {
      dispatch(showError(t("Error exporting power carts")));
      return;
    }
    dispatch(showSuccess(t("Successfully exported power cart list.")));
    onClose();
  }

  function handleRemoveNewEmail(index: number) {
    const emails = state.emails.slice();
    emails.splice(index, 1);

    setState({ ...state, emails: emails });
  }

  return (
    <Popup
      type="export"
      open={open}
      title={t("Export power cart list")}
      onCancel={onClose}
      onOk={() => handleExportCustomerList()}
      okText={t("Export")}
      description={t("Please enter the email addresses where you would like to receive the exported power cart list.")}
    >
      <br />
      <TagInput
        label={t("Add Email")}
        value={state.newEmail}
        onChange={e => setState({ ...state, newEmail: e.target.value !== "," ? e.target.value : state.newEmail })}
        onKeyDown={handleAddNewEmail}
        placeholder={t("Email")}
        tags={state.emails}
        onTagClick={(index: number) => handleRemoveNewEmail(index)}
        helpText={t("Add an email tag with ' , ' or Enter.")}
      />
    </Popup>
  );
}
